var module = angular.module('octopusApp.infrastructure');

module.directive("octoFullScreen", function ($rootScope) {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.html("<i class='fa fa-expand'></i>");

      element.click(function (e) {
        e.preventDefault();
        var target = $(attr.octoFullScreen);
        var exitFullScreen = function() {
          $(".fullscreen-controls", target).remove();
          target.removeClass("fullscreen-content");
          $('body').removeClass("fullscreen-body");
          $rootScope.$broadcast("octo-fullscreen-toggle");
          $(document).unbind("keyup", escapeKeyHandler);
        };

        var escapeKeyHandler = function(e) {
          if (e.keyCode === 27) {
            exitFullScreen();
          }
        };

        $('body').addClass("fullscreen-body");
        $(document).bind("keyup", escapeKeyHandler);

        target.addClass("fullscreen-content");
        target.prepend($("<div class='fullscreen-controls'><a href='' class='exit-full-screen'>Exit full screen</div>"));

        $(".exit-full-screen", target).click(function (e) {
          e.preventDefault();
          exitFullScreen();
          return false;
        });

        $rootScope.$broadcast("octo-fullscreen-toggle");
        return false;
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo-full-screen.js
// module id = 673
// module chunks = 1